import React, { useState } from "react";
import { Container, Tabs, Tab, Form } from "react-bootstrap";
import RaportIstoricSasiu from "./RaportIstoricSasiu";
import RaportProfitDevize from "./RaportProfitDevize";
import RaportDevizeUser from "./RaportDevizeUser";

export default function RapoarteService() {
  const [key, setKey] = useState("istoric");
  const [tipDeviz, setTipDeviz] = useState("");

  return (
    <Container fluid className="py-3">
      <h3 className="mb-4">Rapoarte Service Auto</h3>
      <Form.Group controlId="service-tip-deviz" className="mb-3 d-print-none" style={{ maxWidth: 280 }}>
        <Form.Label>Tip deviz</Form.Label>
        <Form.Select value={tipDeviz} onChange={(e) => setTipDeviz(e.target.value)}>
          <option value="">Toate</option>
          <option value="2">Clienți</option>
          <option value="1">Intern</option>
        </Form.Select>
      </Form.Group>
      <p className="d-none d-print-block">Tip deviz: {tipDeviz === "2" ? "Clienți" : tipDeviz === "1" ? "Intern" : "Toate"}</p>
      <Tabs
        id="rapoarte-service-tabs"
        activeKey={key}
        onSelect={(k) => setKey(k)}
        className="mb-4 d-print-none"
        mountOnEnter
        unmountOnExit
      >
        <Tab eventKey="istoric" title="Istoric Reparații (Căutare Auto/Șasiu)">
          <RaportIstoricSasiu key={tipDeviz} tipDeviz={tipDeviz} />
        </Tab>
        <Tab eventKey="users" title="Devize / utilizator">
          <RaportDevizeUser tipDeviz={tipDeviz} />
        </Tab>
        <Tab eventKey="profit" title="Rentabilitate & Profit Devize">
          <RaportProfitDevize />
        </Tab>
      </Tabs>
    </Container>
  );
}
